<div class="main-content mt-0">
  <div class="container-fluid">
    <div class="row justify-content-center">
      <div class="col-4 col-md-2" *ngFor="let card of resumenCards; index as i">
        <div
          class="card card-stats"
          [ngClass]="{ 'card-stats__selected': i === 2 }"
          [routerLink]="card.route"
          [style.cursor]="card.route ? 'pointer' : 'default'"
        >
          <div class="card-body">
            <div class="row">
              <div class="col-12 col-md-7 col-lg-6">
                <div
                  class="icon-big text-center text-dark rounded shadow"
                  [ngClass]="card.bgClass"
                >
                  <i [class]="card.icon"></i>
                </div>
              </div>
              <div class="col-7 d-flex flex-column justify-content-center">
                <p class="card-category mb-0">{{ card.label }}</p>
                <h4
                  class="card-title mb-0"
                  [ngClass]="{ 'text-dark': i === 2, 'text-white': i !== 2 }"
                >
                  {{ card.value }}
                </h4>
              </div>
            </div>
          </div>
          <div class="card-footer">
            <div class="stats">
              <small [class]="i == 2 ? 'desc__selected' : 'desc'">{{
                card.desc
              }}</small>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- <div class="row mb-6 mt-4">
    <div class="col-12 d-flex align-items-center justify-content-between">
      <div class="flex-grow-1 text-center">
        <a
          class="btn btn-dark btn-sm btn-reg"
          routerLink="/marketing/social/contentRequests"
          >Content Requests
        </a>
        <a
          class="btn btn-dark btn-sm btn-new"
          routerLink="/marketing/social/registry"
          >Social Registry
        </a>
      </div>
    </div>
  </div> -->

    <div class="row mb-4 mt-2 text-center">
      <div class="col-12">
        <div class="platform-cards-container">
          <!-- Instagram -->
          <div
            class="platform-card"
            [ngClass]="{ active: filters.platform === 'instagram' }"
            (click)="
              filters.platform =
                filters.platform === 'instagram' ? '' : 'instagram';
              applyFilters()
            "
          >
            <div class="platform-icon ig">
              <i class="fab fa-instagram"></i>
            </div>
            <span class="platform-name">Instagram</span>
          </div>

          <!-- Facebook -->
          <div
            class="platform-card"
            [ngClass]="{ active: filters.platform === 'facebook' }"
            (click)="
              filters.platform =
                filters.platform === 'facebook' ? '' : 'facebook';
              applyFilters()
            "
          >
            <div class="platform-icon fb">
              <i class="fab fa-facebook-f"></i>
            </div>
            <span class="platform-name">Facebook</span>
          </div>

          <!-- YouTube -->
          <div
            class="platform-card"
            [ngClass]="{ active: filters.platform === 'youtube' }"
            (click)="
              filters.platform =
                filters.platform === 'youtube' ? '' : 'youtube';
              applyFilters()
            "
          >
            <div class="platform-icon yt">
              <i class="fab fa-youtube"></i>
            </div>
            <span class="platform-name">YouTube</span>
          </div>

          <!-- TikTok -->
          <div
            class="platform-card"
            [ngClass]="{ active: filters.platform === 'tiktok' }"
            (click)="
              filters.platform = filters.platform === 'tiktok' ? '' : 'tiktok';
              applyFilters()
            "
          >
            <div class="platform-icon tt">
              <i class="fab fa-tiktok"></i>
            </div>
            <span class="platform-name">TikTok</span>
          </div>
        </div>
      </div>
    </div>

    <div class="row mb-3 mt-4">
      <div class="col-12 d-flex align-items-center justify-content-between">
        <div class="flex-grow-1 text-center">
          <a
            class="btn btn-dark btn-sm btn-new"
            routerLink="/marketing/social/strategy"
            >STRATEGY
          </a>
          <a class="btn btn-dark btn-sm btn-reg">SEMANTIKA </a>
          <!-- <a
            class="btn btn-dark btn-sm btn-new"
            routerLink="/marketing/social/performance"
            >PERFORMANCE
          </a> -->
          <a class="btn btn-dark btn-sm btn-new">NOTES </a>
          <a
            class="btn btn-dark btn-sm btn-new"
            routerLink="/marketing/mediaroom/social"
            >MEDIAROOM
          </a>
        </div>
      </div>
    </div>

    <div class="semantika-container p-4" *ngIf="!loading">
      <!-- Header -->
      <div class="mb-4">
        <h2 class="mb-1 fw-bold text-dark">REPORTS</h2>
        <!-- <p class="text-muted mb-0">
          Select a platform, frequency and period to view Semantika reports.
        </p> -->
      </div>

      <!-- Filters -->
      <div
        class="card shadow-sm border-0 mb-4 bg-white"
        style="border-radius: 6px"
      >
        <div class="card-body p-3">
          <div class="row align-items-end g-3">
            <div class="col-md-3">
              <label class="form-label small fw-bold text-dark mb-1 d-block"
                ><strong>Platform</strong></label
              >
              <div class="input-group input-group-sm">
                <!-- <span class="input-group-text bg-white border-end-0 text-danger"
                  ><i class="fab fa-instagram"></i
                ></span> -->
                <div
                  class="platform-icon"
                  [ngClass]="selectedPlatformInfo.class"
                >
                  <i [class]="selectedPlatformInfo.icon"></i>
                </div>
                <select
                  class="form-select form-select-sm bg-white border shadow-none select-filter-initial"
                  [(ngModel)]="filters.platform"
                >
                  <option
                    *ngFor="let platform of platforms"
                    [value]="platform.value"
                  >
                    {{ platform.label }}
                  </option>
                </select>
              </div>
            </div>
            <div class="col-md-3">
              <label class="form-label small fw-bold text-dark mb-1 d-block"
                ><strong>Report Frequency</strong></label
              >
              <select
                class="form-select form-select-sm bg-white border shadow-none select-filter-initial"
              >
                <option selected>Monthly</option>
                <option>Weekly</option>
              </select>
            </div>
            <div class="col-md-2">
              <label class="form-label small fw-bold text-dark mb-1 d-block"
                ><strong>Reviewed Period</strong></label
              >
              <select
                class="form-select form-select-sm bg-white border shadow-none select-filter-initial"
              >
                <option selected>July 2026</option>
                <option>June 2026</option>
              </select>
            </div>
            <div class="col-md-4 d-flex justify-content-end pb-1">
              <button
                class="btn btn-dark btn-sm px-4 mb-0 d-flex align-items-center rounded btn-initial"
              >
                <i class="fas fa-search mr-2"></i> SEARCH
              </button>
            </div>
          </div>
        </div>
      </div>

      <!-- Summary Card -->
      <div
        class="card shadow-sm border-0 mb-4 mt-3 bg-white custom-scroll-x"
        style="border-radius: 6px"
      >
        <div class="card-body p-2">
          <div class="row align-items-center text-center text-md-start">
            <div
              class="col-md-3 d-flex align-items-center mb-3 mb-md-0 border-muted border-right"
            >
              <div class="platform-icon" [ngClass]="selectedPlatformInfo.class">
                <i [class]="selectedPlatformInfo.icon"></i>
              </div>
              <div class="ml-1 text-left">
                <h4 class="fw-bold mb-1 text-dark fs-5">
                  <strong>{{ selectedPlatformInfo.label }}</strong>
                </h4>
                <div class="text-secondary small fw-medium">Monthly Report</div>
                <div class="text-dark small fw-bold">July 2026</div>
              </div>
            </div>
            <div class="col-md-2 mb-3 mb-md-0 border-muted border-right">
              <div class="text-dark small mb-1">Status</div>
              <span
                class="badge rounded-pill px-3 py-2 fw-medium d-inline-flex align-items-center"
                style="
                  background-color: #e8f5e9;
                  color: #2e7d32;
                  border: 1px solid #c8e6c9;
                "
              >
                <i class="far fa-check-circle me-1"></i> Completed
              </span>
            </div>
            <div class="col-md-2 mb-3 mb-md-0 border-muted border-right">
              <div class="text-dark small mb-1">Snapshot Version</div>
              <div class="fw-bold text-dark">v1.0</div>
            </div>
            <div class="col-md-2 mb-3 mb-md-0 border-muted border-right">
              <div class="text-dark small mb-1 text-center">
                Surfaces Reviewed
              </div>
              <div class="fw-bold text-dark fs-4 text-center">5</div>
            </div>
            <div
              class="col-md-3 mb-3 mb-md-0 px-2 d-flex flex-column flex-xl-row align-items-center justify-content-between"
            >
              <div
                class="me-xl-3 mb-3 mb-xl-0 text-center text-xl-start text-nowrap"
              >
                <div class="text-dark small mb-1">Generated On</div>
                <div class="text-dark small fw-medium">
                  <strong>Aug 3, 2026</strong><br /><strong
                    >09:42 AM UTC</strong
                  >
                </div>
              </div>
              <div
                class="d-flex flex-column gap-2 w-100 ml-2"
                style="max-width: 150px"
              >
                <button
                  class="btn btn-dark btn-sm text-white w-100 d-flex p-1 align-items-center justify-content-center rounded btn-header"
                >
                  <!-- <i class="far fa-eye me-2"></i>-->
                  VIEW FULL REPORT
                </button>
                <button
                  class="btn btn-outline-secondary btn-sm w-100 bg-white p-1 text-dark d-flex align-items-center justify-content-center rounded btn-header"
                >
                  <i class="fas fa-download me-2"></i> EXPORT PDF
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- SURFACES REVIEWED Table -->
      <div
        class="card shadow-sm border-0 mb-4 bg-white"
        style="border-radius: 6px"
      >
        <div class="card-header bg-white border-bottom-0 pt-4 pb-2">
          <h4 class="fw-bold text-dark text-uppercase mb-1 fs-6">
            <strong>SURFACES REVIEWED</strong>
          </h4>
          <p class="text-muted small mb-0">
            All governed Instagram surfaces reviewed in this report and their
            outcomes.
          </p>
        </div>
        <div class="card-body p-0">
          <div class="table-responsive">
            <table class="table align-middle text-sm mb-0">
              <thead class="bg-light text-uppercase">
                <tr>
                  <th
                    class="text-dark small fw-bold border-0 ps-4 py-3 head-table"
                  >
                    <strong>Surface</strong>
                  </th>
                  <th class="text-dark small fw-bold border-0 py-3 head-table">
                    <strong>Review Outcome</strong>
                  </th>
                  <th class="text-dark small fw-bold border-0 py-3 head-table">
                    <strong>Evidence Level</strong>
                  </th>
                  <th
                    class="text-dark small fw-bold border-0 pe-4 py-3 head-table"
                  >
                    <strong>Brief Conclusion</strong>
                  </th>
                </tr>
              </thead>
              <tbody>
                <!-- Feed Posts -->
                <tr class="border-bottom text-dark">
                  <td class="ps-4 fw-bold text-dark">
                    <span class="surface-icon-badge surface-feed mr-2"
                      ><i class="fas fa-th-large"></i
                    ></span>
                    Feed Posts
                  </td>
                  <td>
                    <span class="outcome-badge outcome-conclusion">
                      <i class="fas fa-check-circle mr-1"></i> Conclusion
                      Available
                    </span>
                  </td>
                  <td>
                    <div class="d-flex align-items-center gap-1">
                      <i
                        class="fas fa-circle text-success"
                        style="font-size: 8px"
                      ></i>
                      <i
                        class="fas fa-circle text-success"
                        style="font-size: 8px"
                      ></i>
                      <i
                        class="fas fa-circle text-success"
                        style="font-size: 8px"
                      ></i>
                      <span class="ml-2 text-dark small">Strong</span>
                    </div>
                  </td>
                  <td class="text-dark pe-4 small">
                    Reliability and service clarity dominated competitor
                    messaging.
                  </td>
                </tr>
                <!-- Reels -->
                <tr class="border-bottom text-dark">
                  <td class="ps-4 fw-bold text-dark">
                    <span class="surface-icon-badge surface-reels mr-2"
                      ><i class="fas fa-film"></i
                    ></span>
                    Reels
                  </td>
                  <td>
                    <span class="outcome-badge outcome-conclusion">
                      <i class="fas fa-check-circle mr-1"></i> Conclusion
                      Available
                    </span>
                  </td>
                  <td>
                    <div class="d-flex align-items-center gap-1">
                      <i
                        class="fas fa-circle text-success"
                        style="font-size: 8px"
                      ></i>
                      <i
                        class="fas fa-circle text-success"
                        style="font-size: 8px"
                      ></i>
                      <i
                        class="fas fa-circle"
                        style="font-size: 8px; color: #ccc"
                      ></i>
                      <span class="ml-2 text-dark small">Moderate</span>
                    </div>
                  </td>
                  <td class="text-dark pe-4 small">
                    Short-form content emphasized urgency and immediate
                    response.
                  </td>
                </tr>
                <!-- Stories -->
                <tr class="border-bottom text-dark">
                  <td class="ps-4 fw-bold text-dark">
                    <span class="surface-icon-badge surface-stories mr-2"
                      ><i class="far fa-circle"></i
                    ></span>
                    Stories
                  </td>
                  <td>
                    <span class="outcome-badge outcome-insufficient">
                      <i class="fas fa-pause-circle mr-1"></i> Insufficient
                      Evidence
                    </span>
                  </td>
                  <td>
                    <div class="d-flex align-items-center gap-1">
                      <i
                        class="fas fa-circle text-warning"
                        style="font-size: 8px"
                      ></i>
                      <i
                        class="fas fa-circle text-warning"
                        style="font-size: 8px"
                      ></i>
                      <i
                        class="fas fa-circle"
                        style="font-size: 8px; color: #ccc"
                      ></i>
                      <span class="ml-2 text-dark small">Limited</span>
                    </div>
                  </td>
                  <td class="text-dark pe-4 small">
                    Activity was too limited to support a consolidated
                    conclusion.
                  </td>
                </tr>
                <!-- Carousels -->
                <tr class="border-bottom text-dark">
                  <td class="ps-4 fw-bold text-dark">
                    <span class="surface-icon-badge surface-carousels mr-2"
                      ><i class="fas fa-images"></i
                    ></span>
                    Carousels
                  </td>
                  <td>
                    <span class="outcome-badge outcome-no-finding">
                      <i class="fas fa-minus-circle mr-1"></i> No Material
                      Finding
                    </span>
                  </td>
                  <td>
                    <div class="d-flex align-items-center gap-1">
                      <i
                        class="fas fa-circle text-primary"
                        style="font-size: 8px"
                      ></i>
                      <i
                        class="fas fa-circle text-primary"
                        style="font-size: 8px"
                      ></i>
                      <i
                        class="fas fa-circle"
                        style="font-size: 8px; color: #ccc"
                      ></i>
                      <span class="ml-2 text-dark small">Moderate</span>
                    </div>
                  </td>
                  <td class="text-dark pe-4 small">
                    Content was reviewed, but no material semantic pattern
                    emerged.
                  </td>
                </tr>
                <!-- Live -->
                <tr class="text-dark">
                  <td class="ps-4 fw-bold text-dark">
                    <span class="surface-icon-badge surface-live mr-2"
                      ><i class="fas fa-broadcast-tower"></i
                    ></span>
                    Live
                  </td>
                  <td>
                    <span class="outcome-badge outcome-no-activity">
                      <i class="fas fa-minus-circle mr-1"></i> No Activity
                      Observed
                    </span>
                  </td>
                  <td>
                    <div class="d-flex align-items-center gap-1">
                      <i
                        class="fas fa-circle"
                        style="font-size: 8px; color: #ccc"
                      ></i>
                      <i
                        class="fas fa-circle"
                        style="font-size: 8px; color: #ccc"
                      ></i>
                      <i
                        class="fas fa-circle"
                        style="font-size: 8px; color: #ccc"
                      ></i>
                      <span class="ml-2 text-dark small">N/A</span>
                    </div>
                  </td>
                  <td class="text-dark pe-4 small">
                    No qualifying competitor activity was observed.
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>

      <!-- COMPETITORS Table -->
      <div
        class="card shadow-sm border-0 mb-1 bg-white"
        style="border-radius: 6px"
      >
        <div class="card-header bg-white border-bottom-0 pt-4 pb-2">
          <h4 class="fw-bold text-dark text-uppercase mb-1 fs-6">
            <strong>COMPETITORS REVIEWED (July 2026)</strong>
          </h4>
        </div>
        <div class="card-body p-0">
          <div class="table-responsive">
            <table class="table align-middle text-sm mb-0">
              <thead class="bg-light text-uppercase">
                <tr>
                  <th
                    class="text-dark small fw-bold border-0 ps-4 py-3 head-table"
                  >
                    Competitor
                  </th>
                  <th class="text-dark small fw-bold border-0 py-3 head-table">
                    City
                  </th>
                  <th class="text-dark small fw-bold border-0 py-3 head-table">
                    Website
                  </th>
                  <th class="text-dark small fw-bold border-0 py-3 head-table">
                    Categories Observed
                  </th>
                  <th class="text-dark small fw-bold border-0 py-3 head-table">
                    Surfaces Observed
                  </th>
                  <th
                    class="text-dark small fw-bold border-0 pe-4 py-3 head-table"
                  >
                    Details
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr class="border-bottom text-dark">
                  <td class="ps-4 fw-medium">Court Express NYC</td>
                  <td class="text-dark">New York, NY</td>
                  <td>
                    <a
                      href="https://courtexpressnyc.com"
                      target="_blank"
                      class="text-primary text-decoration-none"
                      >courtexpressnyc.com
                      <i
                        class="fas fa-external-link-alt"
                        style="font-size: 9px"
                      ></i
                    ></a>
                  </td>
                  <td class="text-dark small">Legal Courier Services</td>
                  <td class="text-dark small">
                    Feed, Reels, Stories, Carousels
                  </td>
                  <td class="pe-4">
                    <a href="#" class="text-primary fw-medium small">View</a>
                  </td>
                </tr>
                <tr class="border-bottom text-dark">
                  <td class="ps-4 fw-medium">Legal Couriers Miami</td>
                  <td class="text-dark">Miami, FL</td>
                  <td>
                    <a
                      href="https://legalcouriersmiami.com"
                      target="_blank"
                      class="text-primary text-decoration-none"
                      >legalcouriersmiami.com
                      <i
                        class="fas fa-external-link-alt"
                        style="font-size: 9px"
                      ></i
                    ></a>
                  </td>
                  <td class="text-dark small">
                    Legal Courier Services<br />Same-Day Courier Services
                  </td>
                  <td class="text-dark small">Feed, Reels, Stories</td>
                  <td class="pe-4">
                    <a href="#" class="text-primary fw-medium small">View</a>
                  </td>
                </tr>
                <tr class="border-bottom text-dark">
                  <td class="ps-4 fw-medium">Swift Legal Delivery</td>
                  <td class="text-dark">London, UK</td>
                  <td>
                    <a
                      href="https://swiftlegaldelivery.co.uk"
                      target="_blank"
                      class="text-primary text-decoration-none"
                      >swiftlegaldelivery.co.uk
                      <i
                        class="fas fa-external-link-alt"
                        style="font-size: 9px"
                      ></i
                    ></a>
                  </td>
                  <td class="text-dark small">Legal Courier Services</td>
                  <td class="text-dark small">
                    Feed, Reels, Stories, Carousels
                  </td>
                  <td class="pe-4">
                    <a href="#" class="text-primary fw-medium small">View</a>
                  </td>
                </tr>
                <tr class="border-bottom text-dark">
                  <td class="ps-4 fw-medium">LA Legal Runners</td>
                  <td class="text-dark">Los Angeles, CA</td>
                  <td>
                    <a
                      href="https://lalegaldrunners.com"
                      target="_blank"
                      class="text-primary text-decoration-none"
                      >lalegaldrunners.com
                      <i
                        class="fas fa-external-link-alt"
                        style="font-size: 9px"
                      ></i
                    ></a>
                  </td>
                  <td class="text-dark small">
                    Legal Courier Services<br />Same-Day Courier Services
                  </td>
                  <td class="text-dark small">Feed, Stories, Carousels</td>
                  <td class="pe-4">
                    <a href="#" class="text-primary fw-medium small">View</a>
                  </td>
                </tr>
                <tr class="text-dark">
                  <td class="ps-4 fw-medium">Prime Same-Day Courier</td>
                  <td class="text-dark">Chicago, IL</td>
                  <td>
                    <a
                      href="https://primesamedaycourier.com"
                      target="_blank"
                      class="text-primary text-decoration-none"
                      >primesamedaycourier.com
                      <i
                        class="fas fa-external-link-alt"
                        style="font-size: 9px"
                      ></i
                    ></a>
                  </td>
                  <td class="text-dark small">
                    Same-Day Courier Services<br />Legal Courier Services
                  </td>
                  <td class="text-dark small">Feed, Reels, Stories</td>
                  <td class="pe-4">
                    <a href="#" class="text-primary fw-medium small">View</a>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>

      <!-- Bottom row -->
      <div class="row g-4 mb-4">
        <!-- SEMANTIC FINDINGS -->
        <div class="col-lg-6 pr-0">
          <div
            class="card shadow-sm border-0 h-100 bg-white"
            style="border-radius: 6px"
          >
            <div
              class="card-header bg-white border-bottom-0 pt-4 pb-2 d-flex align-items-center"
            >
              <div
                class="text-white rounded-circle d-flex align-items-center justify-content-center mr-3 flex-shrink-0"
                style="width: 40px; height: 40px; background: #5c6bc0"
              >
                <i class="far fa-lightbulb"></i>
              </div>
              <h4 class="fw-bold text-dark text-uppercase mb-0 fs-6">
                <strong>SEMANTIC FINDINGS (July 2026)</strong>
              </h4>
            </div>
            <div class="card-body pt-2">
              <!-- Finding 1 -->
              <div class="mb-3">
                <div class="d-flex align-items-center mb-1">
                  <span class="fw-bold text-dark small mr-2"
                    ><strong> Reliability-Led Positioning</strong></span
                  >
                  <span class="badge badge-scope mr-1">Platform-Wide</span>
                  <span class="badge badge-strong">Strong</span>
                </div>
                <p class="text-dark small mb-0">
                  Reliability, service clarity, and operational certainty
                  remained the dominant competitor positioning themes across
                  Instagram.
                </p>
              </div>
              <!-- Finding 2 -->
              <div class="mb-3">
                <div class="d-flex align-items-center mb-1">
                  <span class="fw-bold text-dark small mr-2"
                    ><strong>Urgency in Short-Form Video</strong></span
                  >
                  <span class="badge badge-scope mr-1">Reels</span>
                  <span class="badge badge-moderate mr-1">Moderate</span>
                  <span class="badge badge-emerging">Emerging</span>
                </div>
                <p class="text-dark small mb-0">
                  Competitors increased the use of immediate-response and
                  rapid-delivery language in short-form video.
                </p>
              </div>
              <!-- Finding 3 -->
              <div class="mb-3">
                <div class="d-flex align-items-center mb-1">
                  <span class="fw-bold text-dark small mr-2"
                    ><strong>Premium Restraint</strong></span
                  >
                  <span class="badge badge-scope mr-1"
                    >Luxury Concierge Services</span
                  >
                  <span class="badge badge-moderate">Moderate</span>
                </div>
                <p class="text-dark small mb-0">
                  Luxury-oriented competitors favored controlled, polished
                  language rather than exaggerated urgency.
                </p>
              </div>
              <a href="#" class="text-primary small fw-medium"
                >View all findings in full report &rarr;</a
              >
            </div>
          </div>
        </div>

        <!-- LANGUAGE PATTERNS -->
        <div class="col-lg-6">
          <div
            class="card shadow-sm border-0 h-100 bg-white"
            style="border-radius: 6px; overflow-x: auto"
          >
            <div
              class="card-header bg-white border-bottom-0 pt-4 pb-2 d-flex align-items-center"
            >
              <div
                class="text-white rounded-circle d-flex align-items-center justify-content-center mr-3 flex-shrink-0"
                style="width: 40px; height: 40px; background: #5c6bc0"
              >
                <i class="fas fa-chart-line"></i>
              </div>
              <h4 class="fw-bold text-dark text-uppercase mb-0 fs-6">
                <strong>LANGUAGE PATTERNS (July 2026)</strong>
              </h4>
            </div>
            <div class="card-body pt-3">
              <div class="row text-md-start" style="min-width: 680px">
                <!-- Recurring Terms -->
                <div
                  class="col-sm-6 col-md-3 mb-4 mb-md-0 tr border-muted border-right"
                >
                  <h6
                    class="text-primary fw-bold mb-3 language-patterns text-nowrap"
                  >
                    Recurring Terms
                  </h6>
                  <ul class="list-unstyled ps-0 mb-0">
                    <li
                      class="mb-3 d-flex align-items-center justify-content-md-start"
                    >
                      <i
                        class="fas fa-circle mr-2"
                        style="color: #5c6bc0; font-size: 6px"
                      ></i>
                      <span class="text-dark small fw-medium">same-day</span>
                    </li>
                    <li
                      class="mb-3 d-flex align-items-center justify-content-md-start"
                    >
                      <i
                        class="fas fa-circle mr-2"
                        style="color: #5c6bc0; font-size: 6px"
                      ></i>
                      <span class="text-dark small fw-medium">reliable</span>
                    </li>
                    <li
                      class="mb-3 d-flex align-items-center justify-content-md-start"
                    >
                      <i
                        class="fas fa-circle mr-2"
                        style="color: #5c6bc0; font-size: 6px"
                      ></i>
                      <span class="text-dark small fw-medium">on time</span>
                    </li>
                    <li
                      class="mb-3 d-flex align-items-center justify-content-md-start"
                    >
                      <i
                        class="fas fa-circle mr-2"
                        style="color: #5c6bc0; font-size: 6px"
                      ></i>
                      <span class="text-dark small fw-medium">trusted</span>
                    </li>
                    <li
                      class="mb-3 d-flex align-items-center justify-content-md-start"
                    >
                      <i
                        class="fas fa-circle mr-2"
                        style="color: #5c6bc0; font-size: 6px"
                      ></i>
                      <span class="text-dark small fw-medium"
                        >professional</span
                      >
                    </li>
                    <li
                      class="d-flex align-items-center justify-content-md-start"
                    >
                      <i
                        class="fas fa-circle mr-2"
                        style="color: #5c6bc0; font-size: 6px"
                      ></i>
                      <span class="text-dark small fw-medium"
                        >courier service</span
                      >
                    </li>
                  </ul>
                </div>
                <!-- Strong Vocabulary -->
                <div
                  class="col-sm-6 col-md-3 mb-4 mb-md-0 d-flex flex-column border-muted border-right"
                >
                  <h6
                    class="fw-bold mb-3 text-success language-patterns text-nowrap"
                  >
                    Strong Vocabulary
                  </h6>
                  <ul class="list-unstyled ps-0 mb-0">
                    <li
                      class="mb-3 d-flex align-items-center justify-content-md-start"
                    >
                      <i
                        class="fas fa-circle mr-2 text-success"
                        style="font-size: 6px"
                      ></i>
                      <span class="text-dark small fw-medium">precision</span>
                    </li>
                    <li
                      class="mb-3 d-flex align-items-center justify-content-md-start"
                    >
                      <i
                        class="fas fa-circle mr-2 text-success"
                        style="font-size: 6px"
                      ></i>
                      <span class="text-dark small fw-medium">secure</span>
                    </li>
                    <li
                      class="mb-3 d-flex align-items-center justify-content-md-start"
                    >
                      <i
                        class="fas fa-circle mr-2 text-success"
                        style="font-size: 6px"
                      ></i>
                      <span class="text-dark small fw-medium"
                        >confidential</span
                      >
                    </li>
                    <li
                      class="mb-3 d-flex align-items-center justify-content-md-start"
                    >
                      <i
                        class="fas fa-circle mr-2 text-success"
                        style="font-size: 6px"
                      ></i>
                      <span class="text-dark small fw-medium">dedicated</span>
                    </li>
                    <li
                      class="mb-3 d-flex align-items-center justify-content-md-start"
                    >
                      <i
                        class="fas fa-circle mr-2 text-success"
                        style="font-size: 6px"
                      ></i>
                      <span class="text-dark small fw-medium">white-glove</span>
                    </li>
                    <li
                      class="d-flex align-items-center justify-content-md-start"
                    >
                      <i
                        class="fas fa-circle mr-2 text-success"
                        style="font-size: 6px"
                      ></i>
                      <span class="text-dark small fw-medium">accurate</span>
                    </li>
                  </ul>
                </div>
                <!-- Emerging Expressions -->
                <div
                  class="col-sm-6 col-md-3 mb-4 mb-md-0 d-flex flex-column border-muted border-right"
                >
                  <h6
                    class="fw-bold mb-3 text-warning language-patterns text-nowrap"
                  >
                    Emerging Expressions
                  </h6>
                  <ul class="list-unstyled ps-0 mb-0">
                    <li
                      class="mb-3 d-flex align-items-center justify-content-md-start"
                    >
                      <i
                        class="fas fa-circle mr-2 text-warning"
                        style="font-size: 6px"
                      ></i>
                      <span class="text-dark small fw-medium"
                        >real-time coordination</span
                      >
                    </li>
                    <li
                      class="mb-3 d-flex align-items-center justify-content-md-start"
                    >
                      <i
                        class="fas fa-circle mr-2 text-warning"
                        style="font-size: 6px"
                      ></i>
                      <span class="text-dark small fw-medium"
                        >tailored delivery</span
                      >
                    </li>
                    <li
                      class="mb-3 d-flex align-items-center justify-content-md-start"
                    >
                      <i
                        class="fas fa-circle mr-2 text-warning"
                        style="font-size: 6px"
                      ></i>
                      <span class="text-dark small fw-medium"
                        >seamless handling</span
                      >
                    </li>
                    <li
                      class="mb-3 d-flex align-items-center justify-content-md-start"
                    >
                      <i
                        class="fas fa-circle mr-2 text-warning"
                        style="font-size: 6px"
                      ></i>
                      <span class="text-dark small fw-medium"
                        >direct-to-destination</span
                      >
                    </li>
                    <li
                      class="d-flex align-items-center justify-content-md-start"
                    >
                      <i
                        class="fas fa-circle mr-2 text-warning"
                        style="font-size: 6px"
                      ></i>
                      <span class="text-dark small fw-medium"
                        >priority handling</span
                      >
                    </li>
                  </ul>
                </div>
                <!-- Overused / Saturated -->
                <div
                  class="col-sm-6 col-md-3 d-flex flex-column border-muted border-right"
                >
                  <h6
                    class="fw-bold mb-3 text-danger language-patterns text-nowrap"
                  >
                    Overused /<br />Saturated
                  </h6>
                  <ul class="list-unstyled ps-0 mb-0" style="margin-top: -19px">
                    <li
                      class="mb-3 d-flex align-items-center justify-content-md-start"
                      style="margin-top: 19px"
                    >
                      <i
                        class="fas fa-circle mr-2 text-danger"
                        style="font-size: 6px"
                      ></i>
                      <span class="text-dark small fw-medium">fast</span>
                    </li>
                    <li
                      class="mb-3 d-flex align-items-center justify-content-md-start"
                    >
                      <i
                        class="fas fa-circle mr-2 text-danger"
                        style="font-size: 6px"
                      ></i>
                      <span class="text-dark small fw-medium"
                        >best service</span
                      >
                    </li>
                    <li
                      class="mb-3 d-flex align-items-center justify-content-md-start"
                    >
                      <i
                        class="fas fa-circle mr-2 text-danger"
                        style="font-size: 6px"
                      ></i>
                      <span class="text-dark small fw-medium">we deliver</span>
                    </li>
                    <li
                      class="mb-3 d-flex align-items-center justify-content-md-start"
                    >
                      <i
                        class="fas fa-circle mr-2 text-danger"
                        style="font-size: 6px"
                      ></i>
                      <span class="text-dark small fw-medium">quick</span>
                    </li>
                    <li
                      class="d-flex align-items-center justify-content-md-start"
                    >
                      <i
                        class="fas fa-circle mr-2 text-danger"
                        style="font-size: 6px"
                      ></i>
                      <span class="text-dark small fw-medium">#1 courier</span>
                    </li>
                  </ul>
                </div>
              </div>
              <div class="mt-3">
                <a href="#" class="text-primary small fw-medium"
                  >View full language analysis in report &rarr;</a
                >
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- OVERALL CONCLUSION + TRENDS VS. PRIOR PERIODS -->
      <div class="row g-4 mb-4">
        <!-- OVERALL CONCLUSION -->
        <div class="col-lg-6 pr-0">
          <div
            class="card shadow-sm border-0 h-100 bg-white"
            style="border-radius: 6px"
          >
            <div
              class="card-header bg-white border-bottom-0 pt-4 pb-2 d-flex align-items-center"
            >
              <div
                class="text-white rounded-circle d-flex align-items-center justify-content-center mr-3 flex-shrink-0"
                style="width: 40px; height: 40px; background: #5c6bc0"
              >
                <i class="fas fa-check-double"></i>
              </div>
              <h4 class="fw-bold text-dark text-uppercase mb-0 fs-6">
                <strong>OVERALL CONCLUSION</strong>
              </h4>
            </div>
            <div class="card-body pt-2">
              <p class="text-dark small">
                Competitor activity on Instagram remained centered on
                reliability, service clarity, and operational certainty. Reels
                showed stronger urgency language, while Feed Posts and Carousels
                maintained more stable trust-based positioning. The shift toward
                immediacy is visible but not yet structurally established.
              </p>
            </div>
          </div>
        </div>

        <!-- TRENDS VS. PRIOR PERIODS -->
        <div class="col-lg-6">
          <div
            class="card shadow-sm border-0 h-100 bg-white"
            style="border-radius: 6px"
          >
            <div
              class="card-header bg-white border-bottom-0 pt-4 pb-2 d-flex align-items-center"
            >
              <div
                class="text-white rounded-circle d-flex align-items-center justify-content-center mr-3 flex-shrink-0"
                style="width: 40px; height: 40px; background: #5c6bc0"
              >
                <i class="fas fa-chart-bar"></i>
              </div>
              <h4 class="fw-bold text-dark text-uppercase mb-0 fs-6">
                <strong>TRENDS VS. PRIOR PERIODS</strong>
                <span
                  class="text-muted fw-normal fs-6 ml-2"
                  style="text-transform: none"
                  >(vs. June 2026)</span
                >
              </h4>
            </div>
            <div class="card-body pt-2">
              <div class="d-flex justify-content-around mb-3">
                <!-- Trend 1 -->
                <div class="border-muted border-right pe-4 d-flex align-items-center text-start">
                  <div class="me-3">
                    <span class="trend-icon trend-up"
                      ><i class="fas fa-arrow-up"></i
                    ></span>
                  </div>
                  <div>
                    <div class="text-dark small fw-medium">
                      Urgency language in Reels
                    </div>
                    <div class="fw-bold text-dark small">
                      <strong>Increased</strong>
                    </div>
                  </div>
                </div>
                <!-- Trend 2 -->
                <div class="border-muted border-right px-4 d-flex align-items-center text-start">
                  <div class="me-3">
                    <span class="trend-icon trend-stable"
                      ><i class="fas fa-minus"></i
                    ></span>
                  </div>
                  <div>
                    <div class="text-dark small fw-medium">
                      Reliability positioning
                    </div>
                    <div class="fw-bold text-dark small">
                      <strong>Stable</strong>
                    </div>
                  </div>
                </div>
                <!-- Trend 3 -->
                <div class="ps-4 d-flex align-items-center text-start">
                  <div class="me-3">
                    <span class="trend-icon trend-emerging"
                      ><i class="fas fa-arrow-up"></i
                    ></span>
                  </div>
                  <div>
                    <div class="text-dark small fw-medium">
                      Immediate-response framing
                    </div>
                    <div class="fw-bold text-dark small">
                      <strong>Emerging</strong>
                    </div>
                  </div>
                </div>
              </div>
              <a href="#" class="text-primary small fw-medium"
                >See full trend analysis in report &rarr;</a
              >
            </div>
          </div>
        </div>
      </div>

      <!-- About this report / Methodology Notes -->
      <div
        class="card shadow-sm border-0 mb-4 mt-5 bg-white"
        style="border-radius: 6px"
      >
        <div class="card-body p-3">
          <div class="d-flex align-items-center justify-content-between">
            <div class="d-flex align-items-center">
              <div
                class="text-dark rounded d-flex align-items-center justify-content-center mr-3 flex-shrink-0"
                style="
                  width: 38px;
                  height: 38px;
                  background: #f0f0f0;
                  border-radius: 8px;
                "
              >
                <i class="fas fa-file-alt text-primary"></i>
              </div>
              <div>
                <div class="fw-bold text-dark small mb-1">
                  <strong>About this report / Methodology Notes</strong>
                </div>
                <div class="text-muted" style="font-size: 11px">
                  <strong>Reviewed Period:</strong> July 1&ndash;31, 2026
                  &nbsp;&middot;&nbsp; <strong>Surfaces:</strong> Feed, Reels,
                  Stories, Carousels, Live &nbsp;&middot;&nbsp;
                </div>
                <div class="text-muted" style="font-size: 11px">
                  <strong>Report Closed:</strong> Aug 3, 2026 09:42 AM UTC
                  &nbsp;&middot;&nbsp;
                  <strong>Methodology Version:</strong> v1.0
                  &nbsp;&middot;&nbsp;
                  <strong>Evidence Limitations:</strong> Stories (limited data)
                </div>
              </div>
            </div>
            <i class="fas fa-chevron-right text-muted ml-3"></i>
          </div>
        </div>
      </div>
    </div>
    <div
      *ngIf="loading"
      class="d-flex justify-content-center align-items-center"
      style="min-height: 400px"
    >
      <div class="spinner-border text-primary" role="status">
        <span class="visually-hidden">Loading...</span>
      </div>
    </div>
  </div>
</div>
